import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {

                },
                url: {
                    // getMapFeatures: `${codeAPI}/search/map`,
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            // layerswitcher: {
            //     active: true,
            //     title: 'layerswitcher.titles',
            //     panel: {
            //         show: false,
            //     },
            //     acl: {
            //         view: 'IG_00009',
            //     },
            // },
            // streetview: {
            //     active: true,
            //     title: 'streetview.title',
            //     panel: {
            //         show: false,
            //     },
            //     acl: {
            //         view: 'IG_00008',
            //     },
            // },
            backoffice: {
                active: true,
                title: 'backoffice.title',
                label: 'backoffice.label',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'IG_00006',
                },
                url: {
                    view: `{moduleCode}gestao.home`
                }
            },
            layers: {
                active: true,
                title: 'layers.title',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'IG_00002',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'IG_00007',
                },
            },
            regulations: {
                active: true,
                title: 'regulations.titles',
                label: 'regulations.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'IG_0000X',
                },
                url: {
                    getData: `${codeAPI}/front/regulations`,
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    }],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
                acl: {
                    view: null,
                },
            },
            catalog: {
                acl: {
                    view: 'COSEC_00011',
                },
            },
            identify: {
                acl: {
                    view: 'COSEC_00012',
                },
            },
            print_visible_emissions: {
                active: true,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'COSEC_0000X',
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
            annotations: {
                active: false,
                title: 'annotations.titles',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
                url: {

                },
            },
            measure: {
                active: true,
                title: 'measure.title',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
                url: {

                },
            },
            search: {
                active: true,
                title: 'Filtros',
                label: 'Filtros',
                panel: {
                    show: false,
                    loaded: false,
                    startAutomatically: false,
                    filter: {
                        categories: {
                            highlighted_limit: 4,
                            show_icon: true
                        },
                        slider: {
                            interval: 1,
                            data: [{
                                value: 50,
                                name: '50m',
                            },
                            {
                                value: 100,
                                name: '100m',
                            },
                            {
                                value: 200,
                                name: '200m',
                            },
                            {
                                value: 250,
                                name: '250m',
                            },
                            {
                                value: 300,
                                name: '300m',
                            },
                            {
                                value: 350,
                                name: '350m',
                            },
                            {
                                value: 400,
                                name: '400m',
                            },
                            {
                                value: 450,
                                name: '450m',
                            },
                            {
                                value: 500,
                                name: '500m',
                            },
                            {
                                value: 550,
                                name: '550m',
                            },
                            {
                                value: 600,
                                name: '600m',
                            },
                            {
                                value: 650,
                                name: '650m',
                            },
                            {
                                value: 700,
                                name: '700m',
                            },
                            {
                                value: 750,
                                name: '750m',
                            },
                            {
                                value: 800,
                                name: '800m',
                            },
                            {
                                value: 850,
                                name: '850m',
                            },
                            {
                                value: 900,
                                name: '900m',
                            },
                            {
                                value: 950,
                                name: '950m',
                            },
                            {
                                value: 1000,
                                name: '1km',
                            },
                            {
                                value: 2000,
                                name: '2km',
                            },
                            {
                                value: 3000,
                                name: '3km',
                            },
                            {
                                value: 4000,
                                name: '4km',
                            },
                            {
                                value: 5000,
                                name: '5km',
                            },
                            {
                                value: 6000,
                                name: '6km',
                            },
                            {
                                value: 7000,
                                name: '7km',
                            },
                            {
                                value: 8000,
                                name: '8km',
                            },
                            {
                                value: 9000,
                                name: '9km',
                            },
                            {
                                value: 10000,
                                name: '10km',
                            },
                            {
                                value: 11000,
                                name: '11km',
                            },
                            {
                                value: 12000,
                                name: '12km',
                            }]
                        },
                        inlineFilters: {
                            id: null,
                            model_type: null,
                            name: null,
                            address: null,
                            address_description: null,
                            buffer: 0,
                            categories: [],
                            bbox: null,
                            position: null,
                        },
                    },
                },
                acl: {
                    view: 'PIM_00004',
                    export: 'PIM_00038',
                    showItem: 'PIM_00038',
                },
                url: {
                    getLists: `${codeAPI}/search/lists`,
                    search: `${codeAPI}/search/:type`,
                    searchStreet: '../gateway/address/search',
                },
            },
            tooltip: {
                active: false,
                template: ':name',
                acl: {
                },
            },
            featureviewer: {
                active: true,
                title: 'Elemento',
                panel: {
                    show: false,
                    loaded: false,
                    type: null,
                    item: null,
                },
                acl: {
                    view: 'COSEC_XXXX'
                },
                url: {
                    getShow: `/${codeAPI}/feature/:type/:id`,
                },
            },
        },
        map: {
            loading: false,
            action: null,
            config: {
                layers: {
                },
                interactions: {
                    spiderfier: {
                        displayGeometry: 'spiral',
                        zoomToBoundsPaddingReferenceElement: '.cosec-search',
                    },
                    draw: {
                    },
                },
                style: {
                },
            }
        },
        config: {

        },
    },
};

export default state;